import numeral from 'numeral'

const COLS = [
  { key: 'date', label: 'Date' },
  { key: 'ventes_brutes', label: 'Ventes brutes' },
  { key: 'remboursements', label: 'Remboursements' },
  { key: 'reductions', label: 'Réductions' },
  { key: 'ventes_nettes', label: 'Ventes nettes' },
  { key: 'cout', label: 'Coût des marchandises' },
  { key: 'marge', label: 'Marge brute' },
]

function fmt(v) {
  return numeral(v || 0).format('0,0.00')
}

// rows: array of day objects with `_htg`/`_usd` fields; suffix = 'htg' | 'usd'; totals: same shape.
export async function exportSalesSummaryPDF(rows, totals, suffix, options = {}) {
  const { jsPDF } = await import('jspdf')
  await import('jspdf-autotable')
  // Points + landscape, like the other branded reports (e.g. StoresReportView).
  const doc = new jsPDF('l', 'pt')

  const title = options.title || 'Récapitulatif des ventes'
  doc.setFontSize(12)
  doc.text(title, 40, 46)

  const head = [COLS.map(c => c.label)]
  const body = rows.map(r => COLS.map(c => (c.key === 'date' ? r.date : fmt(r[c.key + '_' + suffix]))))
  if (totals) {
    body.push(COLS.map(c => (c.key === 'date' ? 'TOTAL' : fmt(totals[c.key + '_' + suffix]))))
  }
  // margin.top leaves room for the Keslakay logo header on every page.
  doc.autoTable({ head, body, startY: 56, margin: { top: 56 }, styles: { fontSize: 9 }, headStyles: { fillColor: [25, 65, 115] } })

  // Add the Keslakay logo header + footer to every page (same as the other PDFs).
  const { savePDFWithBranding } = await import('@/utils/pdfHelper')
  await savePDFWithBranding(doc, options.filename || 'recapitulatif_ventes.pdf', { title })
}

export function exportSalesSummaryExcel(rows, totals, suffix, options = {}) {
  const XLSX = require('xlsx')
  const aoa = [COLS.map(c => c.label)]
  rows.forEach(r => aoa.push(COLS.map(c => (c.key === 'date' ? r.date : Math.round((r[c.key + '_' + suffix] || 0) * 100) / 100))))
  if (totals) {
    aoa.push(COLS.map(c => (c.key === 'date' ? 'TOTAL' : Math.round((totals[c.key + '_' + suffix] || 0) * 100) / 100)))
  }
  const ws = XLSX.utils.aoa_to_sheet(aoa)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Récapitulatif')
  XLSX.writeFile(wb, options.filename || 'recapitulatif_ventes.xlsx')
}
